import React from 'react';
import {
  getBillingTypeDisplayName,
  isDomesticRequisitionType
} from '../../util/gearOrderUtil';
import EditIcon from '../EditIcon';
import AlertMessage from '../../AlertMessage';
import EditSection from "../EditSection";
import BillingOptions from "../../BillingOptions";

const BillingInformation = ({
  gearOrder,
  requisition,
  omsRequisition,
  userInfo,
  cancelEdit,
  saveEdit,
  editRef,
  onEdit,
  editingReq,
  editingSection,
  isEditSaveInProgress,
  inlineSaveError,
  canEditReq,
  editSection,
  doNotQuotePrices,
  lastSavedReq,
  lastSavedSection
}) => {
  const domesticRequisitionType = isDomesticRequisitionType(gearOrder);
  const capAuthorized = gearOrder.practitioner?.capAuthorized;

  if (!domesticRequisitionType || gearOrder.physicianInTheLoop
      || capAuthorized) {
    return null;
  }

  if (editingReq === `${requisition?.id}` && editingSection === 'billing') {
    return (
        <div className="mt-20" data-step={`billing-${requisition.id}`}>
          <EditSection
              title="Billing Information"
              onCancel={cancelEdit}
              onSave={saveEdit}
              isEditSaveInProgress={isEditSaveInProgress}
          >
            <BillingOptions
                editRef={(ref) => (editRef.current = ref)}
                userInfo={userInfo}
                gearOrder={gearOrder}
                omsRequisition={omsRequisition}
                activeGearRequisitionId={requisition.id}
                setDirty={() => {}}
                doConfirm={() => {}}
                showError={() => {}}
                setLoading={() => {}}
                setGearOrder={() => {}}
                setOmsRequisition={() => {}}
                setActiveGearRequisitionId={() => {}}
                doNotQuotePrices={doNotQuotePrices}
                updateStep={() => {}}
            />
            {inlineSaveError && <div
                className="validation-error text-danger text-right">{inlineSaveError}</div>}
          </EditSection>
        </div>
    );
  }

  if (userInfo.type === 'prc') {
    // SCR-6829: Do not allow a patient to change the billing method if the client selected "Physician Account"
    const clientSelectedPhysicianBilling =
        requisition.billingMethod
        === process.env.REACT_APP_BILLING_PHYSICIAN_ACCOUNT_VALUE &&
        gearOrder?.workflow?.steps?.find((step) => step.id === 3)?.userType
        === 'myGDX';

    const billingTypeDisplayName = getBillingTypeDisplayName(
		requisition.billingMethod) || 'Not provided';
	  
	let billingOptionDisplay;
	if(!requisition.billingMethod){
		billingOptionDisplay = (
			<AlertMessage type="danger" additionalCssClass="alert-icon-warning mt-10">
				<span>
					Click{' '}
					<button
						type="button"
						className="btn-link btn-unstyled link-underline"
						onClick={() => editSection(`billing_${requisition.id}`)}
					>
						<strong>here</strong>
					</button>{' '}
					to provide missing Billing information.
				</span>
			</AlertMessage>
		);
	} else {
		billingOptionDisplay = (
			<>
				{canEditReq && !clientSelectedPhysicianBilling && (
					<EditIcon
						title="Billing Option"
						onClick={editSection}
						editKey={`billing_${requisition.id}`}
						className="btn btn-edit btn-primary"
						editEl="Edit"
					/>
				)}
				{lastSavedReq === `${requisition.id}` && lastSavedSection === 'billing' && (
					<small>
						<span className="ml-10 text-success">
							Changes saved<i className="ml-5 fa fa-check-circle"></i>
						</span>
					</small>
				)}
			</>
		);
	}

    return (
        <div className="mb-10" data-step={`billing-${requisition.id}`}>
          <strong>Billing Option:</strong> {billingTypeDisplayName}
		  {billingOptionDisplay}
        </div>
    );
  } else if (userInfo.type === 'myGDX') {
    // Require a billing option if the billing step was skipped by the system (this happens with bundle orders)
    const billingStep = gearOrder?.workflow?.steps?.find(
        (step) => step.id === 3 && step.gearReqId === requisition.id);
    const billingOptionRequired = !requisition.dropShip || (billingStep?.skipped
        && billingStep.userType === 'system');

    return (
        <div id="billingInfo" className="space-bottom"
             data-step={`billing-${requisition.id}`}>
          <h4>
            Billing Options
            {canEditReq && (
                <EditIcon
                    title="Billing Options"
                    onClick={editSection}
                    editKey={`billing_${requisition.id}`}
                    className="btn btn-edit btn-primary"
                    editEl="Edit"
                />
            )}
             {lastSavedReq === `${requisition.id}` && lastSavedSection === 'billing' && (
                 <small>
                  <span className="ml-10 text-success">
                     Changes saved<i className="ml-5 fa fa-check-circle"></i>
                  </span>
                 </small>
             )}
          </h4>
          <div>
            {getBillingTypeDisplayName(requisition.billingMethod) ||
                (!billingOptionRequired ? (
                    'Unknown'
                ) : (
                    <AlertMessage type="danger">
                      <strong>
                        A billing option is required. Click{' '}
                        <button type="button" className="btn-link btn-unstyled"
                                onClick={onEdit}>
                          here
                        </button>
                        {' '}
                        to add a billing option to this requisition.
                      </strong>
                    </AlertMessage>
                ))}
          </div>
        </div>
    );
  } else {
    return null;
  }
}

export default BillingInformation;
